import React from 'react';
import styled from 'styled-components';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var LayoutWrapper = styled.div.withConfig({
  displayName: "isolated-chat-layout__LayoutWrapper",
  componentId: "sc-1s7xnvr-0"
})(["position:static;height:100%;width:100%;display:flex;flex-direction:column;overflow:hidden;"]);
var MessageLayer = styled.div.withConfig({
  displayName: "isolated-chat-layout__MessageLayer",
  componentId: "sc-1s7xnvr-1"
})(["flex:1;display:flex;flex-direction:column;min-height:0;overflow:visible;position:static;"]);
var MessageScrollArea = styled.div.withConfig({
  displayName: "isolated-chat-layout__MessageScrollArea",
  componentId: "sc-1s7xnvr-2"
})(["flex:1;overflow:hidden;min-height:0;padding-bottom:0;background-color:#fff;display:flex;flex-direction:column;"]);
var InputLayer = styled.div.withConfig({
  displayName: "isolated-chat-layout__InputLayer",
  componentId: "sc-1s7xnvr-3"
})(["position:static;bottom:auto;left:auto;right:auto;background-color:#fff;border-top:none;z-index:10;flex-shrink:0;"]);
export var IsolatedChatLayout = function IsolatedChatLayout(_ref) {
  var messages = _ref.messages,
      input = _ref.input,
      additionalContent = _ref.additionalContent;
  // Render with isolated layout
  return /*#__PURE__*/_jsxs(LayoutWrapper, {
    children: [/*#__PURE__*/_jsx(MessageLayer, {
      children: /*#__PURE__*/_jsxs(MessageScrollArea, {
        children: [messages, additionalContent]
      })
    }), /*#__PURE__*/_jsx(InputLayer, {
      children: input
    })]
  });
};